import React from "react";
import { tw } from "@careinfo/tailwind";
const Skeleton = () => {
  return (
    <>
      <div
        className={tw`w-full bg-gray-200 rounded-md h-24 mb-8 animate-pulse`}
        style={{ boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)" }}
      ></div>
      <div
        className={tw`w-full bg-gray-200 rounded-md h-16 mb-8 animate-pulse`}
        style={{ boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)" }}
      ></div>
    </>
  );
};

export default Skeleton;
